import { useEffect, useRef } from "react";
import useChatSession from '../../hooks/useChatSession';
import ChatMessageBox from "./component/ChatMessageBox";
import ChatInputBox from "./component/ChatInputBox";
import ChatSuggestedQuestions from "./component/ChatSuggestedQuestions";
import ChatTypingIndicator from "./component/ChatTypingIndicator";

const chatWrapClasses =
    "dp-chat-wrap-scroll pt-17.5 px-3.5 pb-4 rounded-xl text-heading " +
    "flex flex-col gap-2.5 overflow-y-auto overflow-x-hidden " +
    "[scrollbar-width:thin] [scrollbar-color:var(--color-primary-surface)_transparent] " +
    "flex-1 min-h-0";

const chatCardClasses =
    "bg-surface border border-border rounded-[calc(var(--spacing)*2.5)] p-2.5 " +
    "shadow-[0_1px_2px_rgba(16,24,40,0.06)] " +
    "[font-family:system-ui,-apple-system,Segoe_UI,Roboto,Arial,sans-serif] m-2.5";

const errorBubbleClasses =
    "bg-primary-surface border border-primary-surface rounded-[calc(var(--spacing)*2.5)] py-3 px-3.5 " +
    "shadow-[0_1px_0_rgba(16,24,40,0.04),0_2px_4px_rgba(16,24,40,0.06)] " +
    "text-sm leading-[1.55] text-heading max-w-full break-words";

const ChatWindow = ({ caseId, isOpen }) => {
    const chatWrapRef = useRef(null);
    const { chatMessages, sendMessage, isLoading, error } = useChatSession(caseId);

    const lastMessage = chatMessages[chatMessages.length - 1];
    const isWaitingForStream = isLoading && lastMessage?.isStreaming && !lastMessage?.message;

    useEffect(() => {
        if (chatWrapRef.current) {
            chatWrapRef.current.scrollTop = chatWrapRef.current.scrollHeight;
        }
    }, [chatMessages, isLoading, error]);

    if (!isOpen) return null;

    return (
        <div className="chatbot">
            <div className={chatWrapClasses} ref={chatWrapRef}>
                {chatMessages.map((msg, i) => (
                    msg.isStreaming && !msg.message ? null : <ChatMessageBox key={i} message={msg} />
                ))}
                {isWaitingForStream && <ChatTypingIndicator />}
                {error && <div className={errorBubbleClasses}>{error}</div>}
            </div>
            <div className={chatCardClasses}>
                <ChatSuggestedQuestions sendMessage={sendMessage} />
                <ChatInputBox sendMessage={sendMessage} isLoading={isLoading} />
            </div>
        </div>
    );
};

export default ChatWindow;
